import { SelectOption } from "../../../libs/types";
import { LeaseType, ModeOfPaymentType, Pattern, PaymentType, UsageType } from "./types";

export const usageTypeOptions: SelectOption<UsageType>[] = [
  { label: "Residential", value: "residential" },
  { label: "Commercial", value: "commercial" },
];

export const paymentModeOptions: SelectOption<ModeOfPaymentType>[] = [
  { label: "Cheque", value: "cheque" },
  { label: "Cash", value: "cash" },
  { label: "Credit Card", value: "credit_card" },
  { label: "Debit Card", value: "debit_card" },
  { label: "Bank Transfer", value: "bank_transfer" },
];

export const paymentTypeOptions: SelectOption<PaymentType>[] = [
  { label: "Fixed", value: "fixed" },
  { label: "percentage", value: "percentage" },
];

export const leaseTypeOptions: SelectOption<LeaseType>[] = [
  { label: "New", value: "new" },
  { label: "Renewal", value: "renewal" },
];

export const patternOptions: SelectOption<Pattern>[] = [
  { label: "Recurring", value: "recurring" },
  { label: "Non Recurring", value: "nonrecurring" },
];
